<template>
    <v-row>
        <v-col lg="12" md="12">
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="value"
                        :label="label"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="{ ...on, input: $event => $emit('input', $event) }"
                        date-format="MM/dd/yyyy"
                        clearable
                        :disabled="isDisabledElemsOnStaff"
                    ></v-text-field>
                </template>
                <v-date-picker @input="updateValue"></v-date-picker>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: {
        label: {
            type: String,
            default: 'Pick a date'
        },
        format: {
            type: String,
            default: 'MM/dd/yyyy'
        },
        defaultDate: {
            type: String
        },
        isDisabledElemsOnStaff: Boolean,
    },

    data: () => ({
        menu: false,
        value: ''
    }),

    created() {
        this.value = this.defaultDate;
        this.updateValue(this.value);
    },

    watch: {
        defaultDate: {
            handler(newValue) {
                this.updateValue(newValue);
            }
        },

        isFormDialogOpen(val) {
            if (!val) {
                this.value = this.defaultDate
            }
        }
    },

    computed: {
        ...mapState('shifts', {
            isFormDialogOpen: state => state.isFormDialogOpen
        })
    },

    methods: {
        updateValue(value) {
            this.value = value;
            this.$emit('input', value);
            this.menu = false;
        }
    }
};
</script>
